import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import CustomAlert from "../../shared/CustemAlert";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API;

export default function Add({ increment, counter }) {
  const [title, setTitle] = useState(""); // useState hook
  const [error, setError] = useState(false);
  const [isAdded, SetIsAdded] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const [newHotem, setNewHotem] = useState({
    full_name: "",
    full_name_arb: "",
    tafkeed: "",
    tafkeed_arb: "",
    start_date: null,
    end_date: null,
    active: false,
  });

  // handle change event
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    if (name === "active") {
      setNewHotem((prevState) => ({
        ...prevState,
        active: e.target.checked,
      }));
    } else
      setNewHotem((prevState) => ({
        ...prevState,
        [name]: value,
      }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const postData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "jobs/hotem/",
          newHotem,
          {
            signal: controller.signal,
          }
        );
        SetIsAdded(true);
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    postData();
    setTitle("");
    setError(false);
  };
  // render

  return (
    <div>
      <center>
        <div className="card text-dark bg-light container p-3 border  ">
          <div className="card-header">
            <h2>החותמים</h2>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <div className="form-group">
                    <label htmlFor="full_name">שם החותם</label>
                    <input
                      type="text"
                      name="full_name"
                      value={newHotem.full_name}
                      onChange={handleChange}
                      className="form-control"
                      id="full_name"
                      placeholder="תקליד שם מלא"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="tafkeed">תפקיד החותם</label>
                    <input
                      type="text"
                      name="tafkeed"
                      value={newHotem.tafkeed}
                      onChange={handleChange}
                      className="form-control"
                      id="tafkeed"
                      placeholder="תקליד את התפקיד שיופיע בחתימה"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="full_name_arb">שם החותם (בערבית)</label>
                    <input
                      type="text"
                      name="full_name_arb"
                      value={newHotem.full_name_arb}
                      onChange={handleChange}
                      className="form-control"
                      id="full_name_arb"
                      placeholder="תקליד שם מלא"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="tafkeed_arb">תפקיד החותם(בערבית)</label>
                    <input
                      type="text"
                      name="tafkeed_arb"
                      value={newHotem.tafkeed_arb}
                      onChange={handleChange}
                      className="form-control"
                      id="tafkeed_arb"
                      placeholder="תקליד את התפקיד שיופיע בחתימה"
                    />
                  </div>

                  <Col>
                    <div className="form-group">
                      <label htmlFor="start_date">תקופה מ-</label>
                      <input
                        type="date"
                        name="start_date"
                        className="form-control"
                        id="start_date"
                        value={newHotem.start_date}
                        placeholder=""
                        onChange={handleChange}
                      />
                    </div>
                  </Col>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="end_date">תקופה עד-</label>
                      <input
                        type="date"
                        name="end_date"
                        className="form-control"
                        id="end_date"
                        value={newHotem.end_date}
                        placeholder=""
                        onChange={handleChange}
                      />
                    </div>
                  </Col>

                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף חותם חדש
                  </button>
                </form>
              </Col>
            </Row>

            {isAdded && (
              <CustomAlert
                setShow={SetIsAdded}
                alertHeader={title}
                alertBody="החותם נוסף בהצלחה"
              />
            )}
          </div>
        </div>
      </center>
    </div>
  );
}
